<template>
  <div class="picmanger">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>角色配置</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div v-if="!isAuth"
         class="main">
      <div class="head">
        <h4>角色配置</h4>
        <p @click="addRole"
           :style="{'border':'none','color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">+新增角色</p>
      </div>

      <div class="tablebg"
           v-loading="isRefresh">
        <div style="width:100%;margin:0 auto;">
          <rolemanagetable :tableData="roleTableList"
                           @authClick="authClick"
                           @formSubmit="formSubmit"
                           @removeClick="removeClick"
                           @refreshCom="refreshCom"></rolemanagetable>
        </div>

        <div class="pagination">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page.sync="currentPage"
                         :page-size="pageSize"
                         layout="prev, pager, next"
                         :total="total">
          </el-pagination>
        </div>

      </div>
    </div>

    <div v-if="isAuth"
         class="main">
      <div class="head">
        <h4>角色授权：{{authTitle}}</h4>
      </div>
      <div class="tablebg">
        <div style="width:calc(100% - 80px);margin:0 auto;padding:20px;">
          <roleform :id="roleId"
                    :formValue="formValue"
                    @closeForm="closeForm"
                    @submitForm="submitForm"></roleform>
        </div>
      </div>
    </div>

    <!-- <div v-if="isAuth" class="bottombtn">
      <div class="btn">
        <el-button @click="closeRoleForm">取消</el-button>
        <el-button @click="submit('ruleForm')" type="primary">确认</el-button>
      </div>
    </div>-->

    <mydialog @changedialogFormVisible="changedialogFormVisible"
              @dialogSubmit="dialogSubmit"
              :title="title"
              :myform="myform"
              :label="label"
              :dialogFormVisible="tableDialogFormVisible"></mydialog>
  </div>
</template>

<script>
import { rolemanagetable, roleform, dialog } from "@/components/index";
import {
  listAuthRole,
  updateAuthRole,
  addAuthRole,
  deleteAuthRole,
  getAuthRole,
  getPowers,
  setPowers,
  getAuthRoleAccess
} from "@/api/authRole";
import { getDate } from "@/plugins/getdate";
export default {
  components: {
    rolemanagetable: rolemanagetable,
    roleform: roleform,
    mydialog: dialog
  },
  watch: {
    // '$store.state.user.dialogFormVisible'(data){
    //   this.dialogFormVisible = data
    // },
    tableDialogFormVisible (data) {
      this.tableDialogFormVisible = data;
    }
  },
  data () {
    return {
      roleId: '',
      formValue: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      authTitle: "超级管理员",
      isAuth: false,
      label: ["角色名称", "排序",'状态'],
      title: "新增角色",
      myform: { one: "", two: "" },
      tableDialogFormVisible: false,
      timeInt: '',
      roleTableList: [
        // {
        //   role:'超级管理员',
        //   user:'1名',
        //   power:'125项'
        // },
        // {
        //   role:'主编',
        //   user:'6名',
        //   power:'125项'
        // },
        // {
        //   role:'记者',
        //   user:'147名',
        //   power:'125项'
        // }
      ],

      isRefresh: false
    };
  },
  methods: {


    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val
      let data = { page: (this.currentPage - 1), pageSize: this.pageSize }
      // console.log(data)
      this.listAuthRoleAsync(data)
    },

    refreshCom () {
      this.refresh()
    },

    //刷新表格
    refresh () {

      this.isRefresh = true
      this.handleCurrentChange(this.currentPage);
      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },


    addRole () {
      this.title = '新增角色'
      this.tableDialogFormVisible = true;
      this.myform = { one: "", two: "0" }
    },

    //子组件picmanagetable传递过来的方法：用于新增角色
    dialogSubmit (data) {
      let { systemDate } = getDate()
      let willToPushData = {
        "name": data.one,
        "sort": data.two,
        "type": 0
      }
      // console.log(willToPushData)
      this.addAuthRoleAsync(willToPushData)
    },


    closeRoleForm () {
      this.isAuth = !this.isAuth;
      this.timeInt = setInterval(() => {
        this.handleCurrentChange(this.currentPage);
      }, 90000);
    },
    //roleform关闭窗口事件
    closeForm () {
      this.closeRoleForm();

    },

    //roleform提交表单事件
    submitForm (data) {
      let arr = data
      
      for (let i = 0; i < arr.length; i++) {
        if(arr[i].split('-').length >= 3){
          
          let iof = arr[i].split('-')[0] + '-' + arr[i].split('-')[1]
          if(arr.indexOf(iof) === -1){
            arr.push(iof)
          }
        }
        
      }
      this.setPowersAsync(this.roleId, arr)
      this.closeRoleForm();

    },

    //子组件rolemanagetable中表格点击了授权按钮传递过来的事件
    authClick (data) {
      // this.authClick = data.row.name
      this.isAuth = true;
      clearTimeout(this.timeInt)
      this.getPowersAsync(data.row.id)
      this.authTitle = data.row.name

    },
    //修改图片库信息事件
    formSubmit (data) {
      let willToPushData = {
        "name": data.one,
        "sort": data.two,
        "type": 0,
        "id": data.id
      }
      this.updateAuthRoleAsync(willToPushData);
    },
    // changeClick(data) {
    //   this.getAuthRoleAsync(data.row.id)
    //   this.title = '修改角色'
    //   this.changedialogFormVisible(true)
    // },
    removeClick (data) {
      this.$confirm("确定删除角色吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          this.deleteAuthRoleAsync(data.row.id)
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });
    },



    //子组件dialog的方法：用于修改是否隐藏dialog的值   不予picmanagetable组件中的dialog组件重复
    changedialogFormVisible (data) {
      this.tableDialogFormVisible = data;

    },

    //获取角色列表
    async listAuthRoleAsync (val) {
      this.isRefresh = true
      let { status, data, message, pagination, errors } = await listAuthRole(val);
      if (status) {

        for (let i = 0; i < data.length; i++) {
          let powerList = await getPowers(data[i].id)
          let rolePerson = await getAuthRoleAccess({ roleId: data[i].id, pageSize: 200 })
          data[i].powerNum = powerList.data.length + '项'
          data[i].rolePerson = rolePerson.data
          data[i].roleNum = data[i].rolePerson.length + '人'
        }
        this.total = pagination.total
        this.roleTableList = data;
        this.isRefresh = false
        // this.roleTableList.forEach((e,i)=>{
        //   this.getPowersAsync(e.id,i)
        // })
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    },

    //获取角色权限列表
    async getPowersAsync (val, i) {
      this.isRefresh = true
      let { status, data, message, errors } = await getPowers(val);
      if (status) {
        // if(i){
        //   this.roleTableList[i].powerNum = data.length
        //   console.log(this.roleTableList)
        // }else{
        this.roleId = val
        this.formValue = []
        if (data.length === 0) {
          this.formValue = []
        } else {
          data.forEach((e) => {
            this.formValue.push(e.name)
          })
        }
        console.log(this.formValue);
        this.isRefresh = false
        // }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    },

    //修改角色权限
    async setPowersAsync (ps, val) {
      let { status, data, message, errors } = await setPowers(ps, val);
      if (status) {
        this.$message.success("修改成功！");
        const h = this.$createElement;
        this.$notify({
          title: '友情提醒',
          message: h('strong', { style: '' }, '角色权限修改完成，请该用户5分钟后重新登录！'),
          duration: 5000
        });
        this.handleCurrentChange(this.currentPage);

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //删除角色
    async deleteAuthRoleAsync (val) {
      let { status, data, message, errors } = await deleteAuthRole(val);
      if (status) {
        this.$message.success("删除成功！");
        const h = this.$createElement;
        this.$notify({
          title: '友情提醒',
          message: h('strong', { style: '' }, '删除角色后请在平台运维中清除所有用户权限缓存方可生效。'),
          duration: 3000
        });
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //查询角色
    async getAuthRoleAsync (val) {
      let { status, data, message, errors } = await getAuthRole(val);
      if (status) {
        this.myform.one = data.name
        this.myform.two = data.sort
        this.myform.id = data.id
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //添加角色信息
    async addAuthRoleAsync (val) {
      let { status, data, message, errors } = await addAuthRole(val);
      if (status) {
        this.changedialogFormVisible(false)
        this.$message.success("添加成功！");
        this.handleCurrentChange(1);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //修改角色信息
    async updateAuthRoleAsync (val) {
      let { status, data, message, errors } = await updateAuthRole(val);
      if (status) {
        // this.mydialogVisible = false;
        this.$message.success("修改成功！");
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    }
  },
  created () {

    this.handleCurrentChange(this.currentPage);
    this.timeInt = setInterval(() => {
      this.handleCurrentChange(this.currentPage);
    }, 30000);
  },
  beforeDestroy () {  // 组件销毁前调用
    clearTimeout(this.timeInt)
  },
  mounted () { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./rolemanage.scss";

h4 {
  font-size: 18px;
}
</style>

